import React from 'react';
import CalendarContext from '@calendar/state/CalendarContext';

export const useCalendarContext = () => {
	const ctx = React.useContext(CalendarContext);
	if (!ctx) { throw new Error('useCalendarContext must be used inside CalenderProvider'); }
	return ctx;
};
